import { LoanStatus } from "../../../enums/activeLoans/loanStatus";
import { LoanType } from "../../../enums/activeLoans/loanType";
import { LoanDescriptionData } from "../../../models/loans/loanDescriptionData";
import { BaseLoansData, LoansData } from "../../../models/loans/loansData";
import { LoanTransactionData } from "../../../models/loans/loanTransactionData";

const transactions = [
  {
    date: "2024-10-10T12:00:00Z",
    activity: "Betaling",
    transactionTypeOriginal: "Payment",
    amount: -2530.12,
    loanBalance: -1000.0,
  },
  {
    date: "2024-10-10T12:00:00Z",
    activity: "Morarenter",
    transactionTypeOriginal: "Interest",
    amount: 25.0,
    loanBalance: -975.0,
  },
  {
    date: "2024-01-01T12:00:00Z",
    activity: "Lånerenter",
    transactionTypeOriginal: "Interest accrual",
    amount: 5.955,
    loanBalance: 5.955,
  },
  {
    date: "2024-01-01T12:00:00Z",
    activity: "Hovedstol",
    transactionTypeOriginal: "Loan capital",
    amount: 2000,
    loanBalance: 2005.955,
  },
  {
    date: "2024-02-01T12:00:00Z",
    activity: "Lånerenter",
    transactionTypeOriginal: "Transfer to collection capital",
    amount: 5.955,
    loanBalance: 2011.91,
  },
  {
    date: "2024-03-01T12:00:00Z",
    activity: "Lånerenter",
    transactionTypeOriginal: "Transfer to collection interest",
    amount: 14.8775,
    loanBalance: 2026.7875,
  },
  {
    date: "2024-03-01T12:00:00Z",
    activity: "Hovedstol",
    transactionTypeOriginal: "Loan capital",
    amount: 3000,
    loanBalance: 5026.7875,
  },
  {
    date: "2024-03-31T12:00:00Z",
    activity: "Lånerenter",
    transactionTypeOriginal: "Interest accrual",
    amount: 4.4625,
    loanBalance: 5031.25,
  },
  {
    date: "2024-04-01T12:00:00Z",
    activity: "Lånerenter",
    transactionTypeOriginal: "Customer",
    amount: 10.415,
    loanBalance: 5041.665,
  },
  {
    date: "2024-08-31T12:00:00Z",
    activity: "Betaling",
    transactionTypeOriginal: "Instalment",
    amount: 5.4625,
    loanBalance: 5046,
  },
] as LoanTransactionData[];

const loans = [
  {
    bfeNumber: 1234567,
    address: "Krydservej 33, 4444 Karise",
    activeLoans: [
      {
        parentLoanNumber: "5637146831",
        loanType: LoanType.PensionerLoans,
        loanAmount: 25000.0,
        accruedInterest: 591.33,
        latePaymentInterestAmount: 5.11,
        loanEndDate: "2026-01-01T19:54:02",
        balanceToDate: 26091.419,
        startDate: "2025-01-01T19:54:02",
        loanStatus: LoanStatus.Active,
        collateral: 50000.0,
        collateralBound: true,
        deposits: 500.0,
        dueDate: "2025-11-25T19:54:02",
        defaultInterests: 0,
        currentBalanceToDate: 0,
        transactionList: transactions,
        toBePaid: 11000,
      } as LoanDescriptionData,
      {
        parentLoanNumber: "5637146826",
        loanType: LoanType.FreezeLoans,
        loanAmount: 14300.0,
        accruedInterest: 753.77,
        latePaymentInterestAmount: 7.11,
        loanEndDate: "2027-01-05T19:54:02",
        balanceToDate: 10091.93,
        loanStatus: LoanStatus.Due,
        startDate: "2025-03-20T19:54:02",
        collateral: 0.0,
        collateralBound: true,
        deposits: 5000.0,
        defaultInterests: 753.77,
        currentBalanceToDate: 0,
        toBePaid: 0,
        transactionList: transactions,
      } as LoanDescriptionData,
      {
        parentLoanNumber: "5637146826",
        loanType: LoanType.FreezeLoans,
        loanAmount: 2000,
        accruedInterest: 41.665,
        latePaymentInterestAmount: 0,
        loanEndDate: "2024-05-12T12:00:00Z",
        balanceToDate: 5041.665,
        loanStatus: LoanStatus.Paid,
        startDate: "2024-01-01T12:00:00Z",
        collateral: 0,
        collateralBound: true,
        deposits: 0,
        defaultInterests: 0,
        currentBalanceToDate: 5041.665,
        toBePaid: 5041.665,
        transactionList: transactions,
      } as LoanDescriptionData,
    ],
  } as LoansData,
  {
    bfeNumber: 1234568,
    address: "Strandvejen 2, 2670 Greve",
    activeLoans: [
      {
        parentLoanNumber: "5637146831",
        loanType: LoanType.PensionerLoans,
        loanAmount: 25000.0,
        accruedInterest: 591.33,
        latePaymentInterestAmount: 0,
        loanEndDate: "2027-05-15T19:54:02",
        balanceToDate: 25091.93,
        loanStatus: LoanStatus.Transferred,
        startDate: "2025-01-01T19:54:02",
        collateral: 50000.0,
        collateralBound: true,
        deposits: 500.0,
        defaultInterests: 753.77,
        currentBalanceToDate: 15,
        transactionList: transactions,
        toBePaid: 2030.966667,
      } as LoanDescriptionData,
      {
        parentLoanNumber: "5637146831",
        loanType: LoanType.PensionerLoans,
        loanAmount: 26000.0,
        accruedInterest: 600.33,
        latePaymentInterestAmount: 0,
        loanEndDate: "2026-01-01T19:54:02",
        balanceToDate: 26091.419,
        startDate: "2025-01-01T19:54:02",
        loanStatus: LoanStatus.Stopped,
        collateral: 60000.0,
        collateralBound: true,
        deposits: 700.0,
        defaultInterests: 0,
        currentBalanceToDate: 0,
        transactionList: transactions,
        toBePaid: 15000,
      } as LoanDescriptionData,
    ],
  } as LoansData,
  {
    bfeNumber: 1234569,
    address: "Strandvejen 10, 2671 Greve",
    activeLoans: [
      {
        parentLoanNumber: "5637146899",
        loanType: LoanType.FreezeLoans,
        loanAmount: 25000.0,
        accruedInterest: 591.33,
        latePaymentInterestAmount: 0,
        loanEndDate: "2027-05-15T19:54:02",
        balanceToDate: 25091.93,
        loanStatus: LoanStatus.Active,
        startDate: "2025-01-01T19:54:02",
        collateral: 50000.0,
        collateralBound: false,
        deposits: 500.0,
        defaultInterests: 753.77,
        currentBalanceToDate: 15,
        transactionList: transactions,
        toBePaid: 2030.966667,
      } as LoanDescriptionData,
      {
        parentLoanNumber: "5637146899",
        loanType: LoanType.AdditionalLoans,
        loanAmount: 28000.0,
        accruedInterest: 591.33,
        latePaymentInterestAmount: 0,
        loanEndDate: "2027-07-13T21:37:00",
        balanceToDate: 25091.93,
        loanStatus: LoanStatus.Active,
        startDate: "2025-01-01T21:37:00",
        collateral: 50000.0,
        collateralBound: false,
        deposits: 500.0,
        defaultInterests: 420.69,
        currentBalanceToDate: 42,
        transactionList: transactions,
        toBePaid: 2030.966667,
      } as LoanDescriptionData,
      {
        parentLoanNumber: "5637146899",
        loanType: LoanType.AdditionalLoans,
        loanAmount: 28000.0,
        accruedInterest: 591.33,
        latePaymentInterestAmount: 0,
        loanEndDate: "2027-07-13T21:37:00",
        balanceToDate: 25091.93,
        loanStatus: LoanStatus.Active,
        startDate: "2025-01-01T21:37:00",
        collateral: 50000.0,
        collateralBound: false,
        deposits: 500.0,
        defaultInterests: 420.69,
        currentBalanceToDate: 42,
        transactionList: transactions,
        toBePaid: 2030.966667,
      } as LoanDescriptionData,
    ],
  } as LoansData,
] as LoansData[];

export const getLoansSet = {
  loansData: loans,
} as BaseLoansData;
